import { render, staticRenderFns } from "./Params.vue?vue&type=template&id=32168e52&"
import script from "./Params.vue?vue&type=script&lang=js&"
export * from "./Params.vue?vue&type=script&lang=js&"
import style0 from "./Params.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports